import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[header-host]',
})
export class HeaderDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}